// File: pages/RepayLoan.js — live repay (dual Singh + Marathon APIs)

import React from 'react';
import RepayLoan1Component from '../components/repay-loan1';

const RepayLoan = () => {
  return <RepayLoan1Component />;
};

export default RepayLoan;
